import { rgba } from 'polished'

const themesConfig = {
  default: {
    palette: {
      type: 'light',
      primary: {
        main: '#064e75',
        contrastText: '#ffffff',
        background: '#ffffff',
        text: '#ffffff',
        dark: '#255268',
        link: '#00c1dd',
        subtitle: '#a8a8a8',
        warning: '#f74872',
        300: '#5D7290',
        main350: '#E9EDF1',
        main300: '#5D7290',
      },
      secondary: {
        main: '#0073b1',
        contrastText: '#fff',
        intensive: rgba(0, 115, 177, 0.2),
      },
      green: {
        300: '#26DB65',
        500: '#2abf5e',
      },
      grey: {
        main: '#757575',
        light: '#eee',
        veryLight: '#e5e5e5',
        intensive: '#5d5c5c',
        contrastText: '#404040',
        morevertIcon: rgba(0, 0, 0, 0.54),
        300: '#8D8D8D',
      },
      neutrals: {
        200: '#e5e5e5',
        400: '#a3a3a3',
      },
      sky: {
        700: '#0369a1',
      },
      disable: {
        main: '#9E9E9E',
        light: '#E1DFDF',
        progress: '#9E9E9E',
        default: '#9E9E9E',
      },
      light: {
        main: '#fff',
      },
      cover: {
        main: '#03273b',
      },
      available: {
        main: '#d2fddd',
        intensive: '#4fd975',
      },
      used: {
        main: '#ffeaef',
        intensive: '#f74872',
      },
      inactive: {
        main: '#f74872',
        intensive: '#ffeaef',
      },
      button: {
        main: '#fff',
        primary: {
          bg: '#0073b1',
          text: '#fff',
          onHover: {
            bg: '#28d1e8',
          },
          onPress: {
            bg: '#13b4cb',
          },
          disable: {
            bg: '#e5e5e5',
            text: '#a8a8a8',
          },
        },
        delete: {
          bg: '#ff4872',
          text: '#fff',
          onHover: {
            bg: '#fD668B',
          },
          onPress: {
            bg: '#eB335f',
          },
        },
        cancel: {
          bg: '#fff',
          text: '#404040',
          onHover: {
            bg: '#f2f2f2',
          },
          onPress: {
            bg: '#e5e5e5',
          },
        },
      },
      darkGrey: { main: '#404040' },
      darkGreyBlue: { main: '#314152' },
      positive: {
        main: '#6aa84f',
      },
      active: {
        main: '#4fd975',
      },
      negative: {
        main: '#f74872',
        background: rgba(247, 72, 114, 0.2),
      },
      info: {
        main: '#94a3b8',
      },
      warning: {
        main: '#ff9a43',
      },
      informative: {
        main: '#0073b1',
      },
      textHighlight: {
        main: '#0073b1',
      },
      textDanger: {
        main: '#e53e3e',
      },
      background: {
        main: '#f9f9f9',
        default: '#f9f9f9',
        areaHighlight: '#b5b5b5',
        errorLight: '#fff5f8',
        paleSkyBlue: 'rgb(204, 227, 239)',
      },
      register: {
        main: '#f9f9f9',
        background: '#f7f7f7',
        whiteBackground: '#ffffff',
        contrastText: '#a5a5a5',
        textbox: {
          background: '#f0f0f0',
          border: '#e0dfdf',
          contrastText: '#a5a5a5',
        },
      },
      billing: {
        main: '#6caf32',
        positive: '#6caf32',
        menu: {
          disabled: {
            text: '#a8a8a8',
            background: '#f2f2f2',
          },
        },
      },
      map: {
        main: '#a8a8a8',
        informative: '#a8a8a8',
      },
      borderColor: {
        main: '#E1DFDF',
        default: '#E1DFDF',
      },
      errorView: {
        main: '#a8a8a8',
        contrastText: '#a8a8a8',
      },
      richTextEditor: {
        main: '#d3eef0',
        doNotTranslate: {
          background: '#d3eef0',
        },
      },
      notificationPreview: {
        main: '#00bed9',
        aquaBlue: '#00bed9',
        sectionDivider: '#daf2f5',
        coralPink: 'rgb(255, 87, 94)',
        brownGrey: 'rgb(144, 144, 144)',
      },
      metric: {
        main: '#cbd5e0',
        lightGrey: '#cbd5e0',
        lightRed: '#FF6384',
        lightBlue: '#0073b1',
        lightBlue400: '#064e75',
        red300: '#feb2b2',
        red400: '#fc8181',
        red500: '#f56565',
        red600: '#e53e3e',
        red700: '#c53030',
        green300: '#9ae6b4',
        green400: '#68d391',
        green500: '#48bb78',
        green600: '#38a169',
        green700: '#2f855a',
      },
      event: {
        main: '#ff575e',
        eventDate: '#ff575e',
        eventTimezone: '#a8a8a8',
        eventLocation: '#909090',
        eventBorder: '#daf2f5',
        eventBackground: '#f4fbff',
        eventCanceled: '#ff575e',
        eventCanceledText: '#a8a8a8',
        eventCanceledBorder: 'rgba(0, 115, 177, 0.24)',
        eventCanceledBackground: '#fff2f2',
        upcomingBackground: 'rgba(255, 154, 67, 0.06)',
        happeningBackground: 'rgba(79, 217, 117, 0.06)',
        endedBackground: 'rgba(242, 242, 242, 0.38)',
        upcomingBorder: '#fbddc4',
        happeningBorder: '#d0f9db',
        endedBorder: '#e6e5e5',
        canceledBorder: '#fbb1b5',
        textNormal: '#0073b1',
      },
      voucher: {
        activeBadgeBg: '#4fd975',
        activeBadgeTxt: '#FFF',
        canceledBadgeBg: '#f74872',
        canceledBadgeTxt: '#FFF',
        expiredBadgeBg: '#e5e5e5',
        expiredBadgeTxt: '#f74872',
        fullyRedeemBadgeBg: '#1ec4db',
        fullyRedeemBadgeTxt: '#FFF',
      },
      text: {
        main: '#a8a8a8',
        lightGrey: '#a8a8a8',
      },
      snackbar: {
        main: '#5ccb7b',
        success: '#5ccb7b',
      },
      chat: {
        selfTextColor: '#fff',
        selfBubbleColor: '#0073b1',
        userTextColor: '#000',
        userBubbleColor: '#eaf4f8',
        adminTextColor: '#000',
        adminBubbleColor: '#f2f2f2',
        linkTextColor: '#000',
      },
    },
    colors: {
      // NEW DESIGN -V 4
      white: '#FFFFFF',
      black: '#000000',

      'primary-300': '#5D7290',
      'primary-350': '#E9EDF1',
      primary: '#183560',
      'primary-200': '#F1F6FC',
      'primary-lighter': '#FAFDFF',

      'secondary-200': '#008E8A',
      secondary: '#00B2AD',
      'secondary-light': '#DBEFEF',
      'light-grayish-blue': '#E9EDF1',
      'dove-gray': '#646464',
      'grayish-blue': '#AAB2B5',
      lavender: '#E8E8EA',
      'indian-red': '#5ACCCA',

      'grey-50': '#FDFDFD',
      'grey-100': '#C5C5C5',
      'grey-200': '#A8A8A8',
      'grey-300': '#8D8D8D',
      'grey-400': '#646464',

      'neutrals-50': '#fafafa',
      'neutrals-100': '#f5f5f5',
      'neutrals-200': '#e5e5e5',
      'neutrals-300': '#d4d4d4',
      'neutrals-400': '#a3a3a3',
      'neutrals-500': '#737373',
      'neutrals-600': '#525252',
      'neutrals-700': '#404040',
      'neutrals-800': '#262626',
      'neutrals-900': '#171717',
      'neutrals-950': '#0a0a0a',

      'green-50': '#f0fdf4',
      'green-100': '#dcfce7',
      'green-200': '#bbf7d0',
      'green-300': '#86efac',
      'green-400': '#4ade80',
      'green-500': '#22c55e',
      'green-600': '#16a34a',
      'green-700': '#15803d',
      'green-800': '#166534',
      'green-900': '#14532d',
      'green-950': '#052e16',

      'red-50': '#fef2f2',
      'red-100': '#fee2e2',
      'red-200': '#fecaca',
      'red-300': '#fca5a5',
      'red-400': '#f87171',
      'red-500': '#ef4444',
      'red-600': '#dc2626',
      'red-700': '#b91c1c',
      'red-800': '#991b1b',
      'red-900': '#7f1d1d',
      'red-950': '#450a0a',

      'orange-50': '#fffbeb',
      'orange-100': '#fef3c7',
      'orange-200': '#fde68a',
      'orange-300': '#fcd34d',
      'orange-400': '#fbbf24',
      'orange-500': '#f59e0b',
      'orange-600': '#d97706',
      'orange-700': '#b45309',
      'orange-800': '#92400e',
      'orange-900': '#78350f',
      'orange-950': '#451a03',

      'sky-50': '#f0f9ff',
      'sky-100': '#e0f2fe',
      'sky-200': '#bae6fd',
      'sky-300': '#7dd3fc',
      'sky-400': '#38bdf8',
      'sky-500': '#0ea5e9',
      'sky-600': '#0284c7',
      'sky-700': '#0369a1',
      'sky-800': '#075985',
      'sky-900': '#0c4a6e',
      'sky-950': '#082f49',

      'indigo-50': '#eef2ff',
      'indigo-100': '#e0e7ff',
      'indigo-200': '#c7d2fe',
      'indigo-300': '#a5b4fc',
      'indigo-400': '#818cf8',
      'indigo-500': '#6366f1',
      'indigo-600': '#4f46e5',
      'indigo-700': '#4338ca',
      'indigo-800': '#3730a3',
      'indigo-900': '#312e81',
      'indigo-950': '#1e1b4b',

      'primary-500': '#132A4D',
      'menu-active': 'rgba(255,255,255, 0.3)',
    },
    overrides: {
      MuiTooltip: {
        tooltip: {
          color: '#ffffff',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      },
    },
  },
}

export default themesConfig
